/**
 * 浏览器环境模拟 uni-app 常用 API，供从小程序拷来的页面（如 activity-multi）在纯 Vue H5 下运行。
 */
import axios from 'axios'
import { Toast } from 'vant'

let _router = null

export function setH5RouterForUni(router) {
  _router = router
}

function rectFromEl(el) {
  if (!el || !el.getBoundingClientRect) return null
  const r = el.getBoundingClientRect()
  return {
    id: el.id,
    dataset: {},
    width: r.width,
    height: r.height,
    top: r.top,
    left: r.left,
    right: r.right,
    bottom: r.bottom
  }
}

function normalizeMiniPath(url) {
  if (!url) return '/index'
  const qIndex = url.indexOf('?')
  const path = qIndex >= 0 ? url.slice(0, qIndex) : url
  const query = qIndex >= 0 ? url.slice(qIndex) : ''
  let p = path.replace(/^\/+/, '')
  if (p.startsWith('pages/')) {
    p = p.slice('pages/'.length)
  }
  if (p === 'index/index' || p === 'index') {
    return '/index' + query
  }
  return '/' + p.replace(/\/+/g, '/') + query
}

function webviewTargetUrl(url) {
  const m = (url || '').match(/[?&]url=([^&]+)/)
  return m ? decodeURIComponent(m[1]) : null
}

function SelectorQuery() {
  this._vm = null
  this._pendingSelector = null
  this._queue = []
}

SelectorQuery.prototype.in = function (vm) {
  this._vm = vm
  return this
}

SelectorQuery.prototype.select = function (selector) {
  this._pendingSelector = selector
  return this
}

SelectorQuery.prototype.boundingClientRect = function (cb) {
  this._queue.push({
    selector: this._pendingSelector,
    cb: typeof cb === 'function' ? cb : null
  })
  this._pendingSelector = null
  return this
}

SelectorQuery.prototype.exec = function (batchCb) {
  const root = (this._vm && this._vm.$el) || document.body
  const rects = []
  for (let i = 0; i < this._queue.length; i++) {
    const item = this._queue[i]
    let el = null
    try {
      if (item.selector && root.querySelector) {
        el = root.querySelector(item.selector)
      }
    } catch (e) {
      el = null
    }
    const rect = rectFromEl(el)
    rects.push(rect)
    if (item.cb) {
      item.cb(rect)
    }
  }
  this._queue = []
  if (typeof batchCb === 'function') {
    batchCb(rects)
  }
  return this
}

const uni = {}

uni.getSystemInfoSync = function () {
  const ww = window.innerWidth || 375
  const wh = window.innerHeight || 667
  return {
    windowWidth: ww,
    windowHeight: wh,
    screenWidth: ww,
    screenHeight: wh,
    pixelRatio: window.devicePixelRatio || 2
  }
}

uni.showToast = function (opts) {
  const o = opts && typeof opts === 'object' ? opts : { title: opts }
  const message = (o.title != null ? String(o.title) : '') || ''
  const duration = o.duration != null ? Number(o.duration) : 2000
  Toast({
    message,
    duration: Number.isFinite(duration) && duration > 0 ? duration : 2000,
    forbidClick: false,
    overlay: false,
    className: o.className != null ? String(o.className) : ''
  })
}

let _h5LoadingToast = null

uni.showLoading = function (opts) {
  const o = opts && typeof opts === 'object' ? opts : {}
  const message = (o.title != null ? String(o.title) : '') || '加载中...'
  try {
    if (_h5LoadingToast && typeof _h5LoadingToast.clear === 'function') {
      _h5LoadingToast.clear()
    }
  } catch (e) {
    /* ignore */
  }
  _h5LoadingToast = Toast.loading({
    message,
    forbidClick: o.mask !== false,
    duration: 0
  })
}

uni.hideLoading = function () {
  try {
    if (_h5LoadingToast && typeof _h5LoadingToast.clear === 'function') {
      _h5LoadingToast.clear()
    }
  } catch (e) {
    /* ignore */
  }
  _h5LoadingToast = null
  try {
    Toast.clear()
  } catch (e) {
    /* ignore */
  }
}

uni.showModal = function (opts) {
  const title = (opts && opts.title) || ''
  const content = (opts && opts.content) || ''
  const ok = window.confirm(title + (content ? '\n' + content : ''))
  if (opts && typeof opts.success === 'function') {
    opts.success({ confirm: !!ok, cancel: !ok })
  }
}

uni.getStorageSync = function (key) {
  try {
    return window.localStorage.getItem(key)
  } catch (e) {
    return ''
  }
}

uni.setStorageSync = function (key, val) {
  try {
    window.localStorage.setItem(key, String(val))
  } catch (e) {}
}

uni.removeStorageSync = function (key) {
  try {
    window.localStorage.removeItem(key)
  } catch (e) {}
}

uni.redirectTo = function (opts) {
  const url = opts && opts.url
  const outer = webviewTargetUrl(url)
  if (outer) {
    window.location.href = outer
    return
  }
  const path = normalizeMiniPath(url)
  if (_router) {
    _router.replace(path)
  }
}

uni.navigateTo = function (opts) {
  const url = opts && opts.url
  const outer = webviewTargetUrl(url)
  if (outer) {
    window.open(outer, '_blank')
    return
  }
  const path = normalizeMiniPath(url)
  if (_router) {
    _router.push(path)
  }
}

uni.openLocation = function (opts) {
  const lat = opts && opts.latitude
  const lng = opts && opts.longitude
  const name = (opts && opts.name) || ''
  if (lat != null && lng != null) {
    window.open(
      'https://uri.amap.com/marker?position=' + lng + ',' + lat + '&name=' + encodeURIComponent(name),
      '_blank'
    )
  }
}

uni.createInnerAudioContext = function () {
  const audio = new Audio()
  const ctx = {
    autoplay: false,
    play: function () {
      if (ctx.src) {
        audio.src = ctx.src
      }
      return audio.play().catch(function () {})
    },
    stop: function () {
      audio.pause()
      audio.currentTime = 0
    },
    pause: function () {
      audio.pause()
    },
    destroy: function () {
      audio.pause()
      audio.removeAttribute('src')
    },
    /** 与小程序一致：onError(callback) */
    onError: function (fn) {
      if (typeof fn === 'function') {
        audio.addEventListener(
          'error',
          function () {
            try {
              fn()
            } catch (e) {}
          },
          { once: false }
        )
      }
      return ctx
    }
  }
  Object.defineProperty(ctx, 'src', {
    get: function () {
      return audio.src || ''
    },
    set: function (v) {
      audio.src = v || ''
    }
  })
  return ctx
}

uni.createSelectorQuery = function () {
  return new SelectorQuery()
}

/**
 * 仅对自有/内网接口附加 Bearer，避免对外部回调域名带 Authorization
 *（否则会触发 CORS 预检，对方未配 CORS 时 GET 也会失败）。
 */
function shouldAttachBearerTokenForUrl(url) {
  if (!url || typeof url !== 'string') return true
  const u = url.trim()
  if (!/^https?:\/\//i.test(u)) {
    return true
  }
  try {
    const host = new URL(u).hostname.toLowerCase()
    if (host === 'localhost' || host === '127.0.0.1') return true
    if (host === 'wvxvb.cn' || host.endsWith('.wvxvb.cn')) return true
    if (
      typeof window !== 'undefined' &&
      window.location &&
      host === String(window.location.hostname || '').toLowerCase()
    ) {
      return true
    }
    if (/^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/.test(host)) return true
    return false
  } catch (e) {
    return true
  }
}

uni.request = function (opts) {
  if (!opts || !opts.url) {
    return
  }
  const token =
    typeof window !== 'undefined' && window.localStorage
      ? window.localStorage.getItem('token')
      : ''
  const headers = Object.assign({}, opts.header || {})
  const hasAuthHeader = !!(headers.Authorization || headers.authorization)
  if (token && !hasAuthHeader && shouldAttachBearerTokenForUrl(opts.url)) {
    headers.Authorization = 'Bearer ' + token
  }
  axios({
    url: opts.url,
    method: (opts.method || 'GET').toLowerCase(),
    data: opts.data,
    headers: headers,
    timeout: opts.timeout || 10000
  })
    .then(function (res) {
      if (typeof opts.success === 'function') {
        opts.success({ data: res.data, statusCode: res.status })
      }
      if (typeof opts.complete === 'function') {
        opts.complete({ data: res.data, statusCode: res.status })
      }
    })
    .catch(function (err) {
      if (typeof opts.fail === 'function') {
        opts.fail(err)
      }
      if (typeof opts.complete === 'function') {
        opts.complete()
      }
    })
}

if (typeof window !== 'undefined') {
  window.uni = uni
}

export default uni
